const getNextCode = (data, id) => {
  return data.items.find((item) => item.id !== id);
};

export default getNextCode;
